import {
  type ComponentProps,
  lazy,
  Suspense,
  useEffect,
  useState,
} from "react";
import type { ThreadCreateForm } from "@/features/thread/components/forms/ThreadCreateForm";

const LazyThreadCreateForm = lazy(async () => ({
  default: (await import("@/features/thread/components/forms/ThreadCreateForm"))
    .ThreadCreateForm,
}));

/** 初回表示まで読込を遅らせ、その後はフォームの描画インスタンスを保持する。 */
export function DeferredThreadCreateForm(
  props: ComponentProps<typeof ThreadCreateForm>,
): React.ReactElement | null {
  const active = props.active ?? true;
  const [hasRendered, setHasRendered] = useState(active);
  useEffect(() => {
    if (active) setHasRendered(true);
  }, [active]);
  if (!active && !hasRendered) return null;
  return (
    <Suspense
      fallback={
        <div className={props.className} role="status">
          フォームを読み込み中…
        </div>
      }
    >
      <LazyThreadCreateForm {...props} />
    </Suspense>
  );
}
